"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */
var react_1 = __importStar(require("react"));
var compatible_1 = require("@ant-design/compatible");
var antd_1 = require("antd");
var react_router_dom_1 = require("react-router-dom");
var context_1 = require("App/context");
require("antd/lib/menu/style");
var MenuLeft = function () {
    var ctx = react_1.useContext(context_1.ApplicationContext);
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var _a = react_1.useState(), currentEntry = _a[0], setCurrentEntry = _a[1];
    var renderPageEntry = function (page) {
        var _a, _b, _c, _d, _e;
        if ((_a = page.children) === null || _a === void 0 ? void 0 : _a.length) {
            var childHasNavProps = page.children.find(function (c) { return c.navProps; });
            if (childHasNavProps) {
                return (react_1.default.createElement(antd_1.Menu.SubMenu, { key: page.name, title: react_1.default.createElement("span", null,
                        ((_b = page.navProps) === null || _b === void 0 ? void 0 : _b.icon) ? react_1.default.createElement(compatible_1.Icon, { type: (_c = page.navProps) === null || _c === void 0 ? void 0 : _c.icon }) : null,
                        react_1.default.createElement("span", null, (_d = page.navProps) === null || _d === void 0 ? void 0 : _d.title)) }, page.children.map(function (child) { return renderSubPageEntry(child); })));
            }
        }
        return react_1.default.createElement(antd_1.Menu.Item, { key: page.name }, (_e = page.navProps) === null || _e === void 0 ? void 0 : _e.title);
    };
    var renderSubPageEntry = function (page) {
        var _a;
        return (react_1.default.createElement(antd_1.Menu.Item, { key: page.name }, (_a = page.navProps) === null || _a === void 0 ? void 0 : _a.title));
    };
    var handleClick = function (e) {
        var _a;
        // console.log(e);
        var root = ctx.pages.find(function (page) { return page.name === e.keyPath[e.keyPath.length - 1]; });
        if (e.keyPath.length > 1) {
            // look for child
            var child = (_a = root === null || root === void 0 ? void 0 : root.children) === null || _a === void 0 ? void 0 : _a.find(function (page) { return page.name === e.keyPath[0]; });
            if (child === null || child === void 0 ? void 0 : child.routeProps.path) {
                setCurrentEntry({
                    entry: child,
                    parent: root === null || root === void 0 ? void 0 : root.name,
                });
                history.push("" + (root === null || root === void 0 ? void 0 : root.routeProps.path) + (child === null || child === void 0 ? void 0 : child.routeProps.path));
                ctx.toggleNavigationCollapsed();
            }
        }
        else if (root === null || root === void 0 ? void 0 : root.routeProps.path) {
            setCurrentEntry({
                entry: root,
            });
            history.push(root === null || root === void 0 ? void 0 : root.routeProps.path);
            ctx.toggleNavigationCollapsed();
        }
    };
    /**
     * set current entry based on location pathname
     * can be either root or any child of any root.
     *
     * updated, when ever location pathname changes and we have no current Entry set.
     */
    react_1.useLayoutEffect(function () {
        if (location.pathname && !currentEntry) {
            var root = ctx.pages.find(function (page) { return page.routeProps.path === location.pathname; });
            if (!root) {
                var locationParts_1 = location.pathname.split('/');
                ctx.pages.find(function (page) {
                    var _a;
                    var subchild = (_a = page.children) === null || _a === void 0 ? void 0 : _a.find(function (child) {
                        var childPathname = "" + page.routeProps.path + child.routeProps.path;
                        var childLocationParts = childPathname.split('/');
                        if (locationParts_1.length >= childLocationParts.length) {
                            // possible match?
                            var childLocationPartsIndex = childLocationParts.length - 1;
                            if (childLocationParts[childLocationPartsIndex] ==
                                locationParts_1[childLocationPartsIndex]) {
                                return true;
                            }
                        }
                        return childPathname === location.pathname;
                    });
                    if (subchild) {
                        setCurrentEntry({
                            entry: subchild,
                            parent: page.name,
                        });
                        return page;
                    }
                });
            }
            else {
                setCurrentEntry({
                    entry: root,
                });
            }
        }
    }, [location.pathname]);
    var menuOptions = {
        mode: 'inline',
        onClick: handleClick,
        className: 'menu',
    };
    if (currentEntry) {
        if (currentEntry.parent) {
            menuOptions.openKeys = [currentEntry.parent];
            menuOptions.selectedKeys = [currentEntry.entry.name];
        }
        else {
            menuOptions.selectedKeys = [currentEntry.entry.name];
        }
    }
    return (react_1.default.createElement(antd_1.Menu, __assign({}, menuOptions), ctx.pages.filter(function (p) { return p.navProps; }).map(function (page) { return renderPageEntry(page); })));
};
exports.default = MenuLeft;
//# sourceMappingURL=index.js.map